let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ftSMY")).then(() => parcelRequire('7DSXR'));